import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import type { ObjectiveDetailVM, TrainingItemAppraisalVM } from "@academy-context/read/domain/types/shared/training-item-evaluation";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { TrainingItemEvaluationForm } from "@academy-context/primary/shared/training-item-evaluation/training-item-evaluation-form.content";
import {
  buildFormValues,
  schema,
  type FormInputs,
} from "@academy-context/primary/shared/training-item-evaluation/form-validation/training-item-evaluation.schema";
import { useEvaluationSubmit } from "../hooks/use-evaluation-submit";

interface Props {
  participationId: string;
  objectives: ObjectiveDetailVM[];
  appraisal: Nullable<TrainingItemAppraisalVM>;
  onSubmitted: () => void;
}

export const EvaluationFormContainer = ({ participationId, objectives, appraisal, onSubmitted }: Props) => {
  const form = useForm<FormInputs>({ resolver: yupResolver(schema), defaultValues: buildFormValues(objectives, appraisal) });
  const { submit } = useEvaluationSubmit(form, onSubmitted, participationId);

  return <TrainingItemEvaluationForm objectives={objectives} appraisal={appraisal} form={form} onSubmit={form.handleSubmit(submit)} />;
};
